import React from 'react';
import queryString from 'query-string';
import { isUsedOnMobile } from '../util/util';

interface QPlayerSVGElementProps {
	color?: string;
	text?: string;
	atLive?: boolean;
	onClick?: () => {};
	width?: number;
	height?: number;
}

const queryParams = queryString.parse(window.location.search);

export const Live: React.FC<QPlayerSVGElementProps> = (props) => {
	if (isUsedOnMobile(queryParams)) {
		return (
			<svg
				aria-hidden="true"
				className="gobrain-icon gobrain-icon-live live-icon"
				xmlns="http://www.w3.org/2000/svg"
				width="49.902"
				height="10.904"
				viewBox="0 0 49.902 10.904"
			>
				<defs>
					<clipPath id="aLive2">
						<rect width="49.902" height="10.904" transform="translate(0 0)"></rect>
					</clipPath>
				</defs>
				<g transform="translate(0 0)">
					<g>
						<path className={props.atLive ? 'atLive' : 'notAtLive'} d="M5,.452a5,5,0,1,1-5,5,5,5,0,0,1,5-5"></path>
						<path style={{ fill: '#fff' }} d="M 21 0 V 9 H 25.1 V 10.9 H 18.963 V 0 Z"></path>
						<rect style={{ fill: '#fff' }} width="2" height="10.904" transform="translate(26.682 0)"></rect>
						<path style={{ fill: '#fff' }} d="M 39 0 h 2 L 37 11 H 35 L 31 0 h 2 l 3 8 Z"></path>
						<path style={{ fill: '#fff' }} d="M 50 2 H 45 V 4.334 h 4 v 2.05 H 45 V 9 H 50 V 10.9 h -6.68 V 0 H 50 Z"></path>
					</g>
				</g>
			</svg>
		);
	}

	return (
		<svg
			aria-hidden="true"
			className="gobrain-icon gobrain-icon-live live-icon"
			xmlns="http://www.w3.org/2000/svg"
			width="49.902"
			height="10.904"
			viewBox="0 0 49.902 10.904"
		>
			<defs>
				<clipPath id="aLive2">
					<rect width="49.902" height="10.904" transform="translate(0 0)"></rect>
				</clipPath>
			</defs>
			<g transform="translate(0 0)">
				<g>
					<path className={props.atLive ? 'atLive' : 'notAtLive'} d="M5,.452a5,5,0,1,1-5,5,5,5,0,0,1,5-5"></path>
					<path style={{ fill: '#fff' }} d="M21.619,0V8.854H25.1V10.9H18.963V0Z"></path>
					<rect style={{ fill: '#fff' }} width="2.656" height="10.904" transform="translate(26.682 0)"></rect>
					<path style={{ fill: '#fff' }} d="M39,0h2.812L37.943,10.9H34.619L30.751,0h2.827l2.7,8.232Z"></path>
					<path style={{ fill: '#fff' }} d="M49.9,2.128H45.879V4.334h3.557v2.05H45.879V8.776H49.9V10.9h-6.68V0H49.9Z"></path>
				</g>
			</g>
		</svg>
	);
};

export const Play: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18.947" height="20.507" viewBox="0 0 18.947 20.507">
		<path
			id="play"
			d="M9.266,4.11A2.351,2.351,0,0,0,7,6.419V22.3a2.344,2.344,0,0,0,3.444,2.029L24.779,16.39a2.345,2.345,0,0,0,0-4.057L10.444,4.391A2.235,2.235,0,0,0,9.266,4.11Z"
			transform="translate(-7 -4.108)"
			fill="#fff"
		></path>
	</svg>
);

export const Pause: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18.947" height="20" viewBox="0 0 18.947 20">
		<path
			id="pause"
			d="M8.368,5A2.381,2.381,0,0,0,6,7.368V22.632A2.381,2.381,0,0,0,8.368,25H11a2.381,2.381,0,0,0,2.368-2.368V7.368A2.381,2.381,0,0,0,11,5ZM19.947,5a2.381,2.381,0,0,0-2.368,2.368V22.632A2.381,2.381,0,0,0,19.947,25h2.632a2.381,2.381,0,0,0,2.368-2.368V7.368A2.381,2.381,0,0,0,22.579,5Z"
			transform="translate(-6 -5)"
			fill="#fff"
		></path>
	</svg>
);

export const Rewind: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18.596" height="20" viewBox="0 0 18.596 20">
		<path
			id="skip-15-seconds-back"
			d="M9.56.98a.93.93,0,0,0-.639.281L7.527,2.656a.93.93,0,0,0,0,1.315L8.921,5.366a.93.93,0,1,0,1.315-1.315L9.5,3.314l.737-.737A.93.93,0,0,0,9.56.98Zm3.719,0a.93.93,0,0,0-.639.281L11.246,2.656a.93.93,0,0,0,0,1.315L12.64,5.366a.93.93,0,0,0,1.495-1.073,7.437,7.437,0,1,1-8.276,7.389.93.93,0,1,0-1.86,0A9.3,9.3,0,1,0,14.084,2.419.93.93,0,0,0,13.28.98Zm.411,7.447A.7.7,0,0,0,13.005,9l-.393,2.092a.7.7,0,0,0,.686.826h1.511a.814.814,0,0,1,.814.814c0,.672-.505.814-.93.814a2.107,2.107,0,0,1-1.2-.319.7.7,0,0,0-.864,1.1,3.409,3.409,0,0,0,2.063.617,2.169,2.169,0,0,0,2.324-2.208,2.211,2.211,0,0,0-2.208-2.208h-.669l.131-.7h1.818a.7.7,0,1,0,0-1.395Zm-3.008,0a.7.7,0,0,0-.163.033l-1.395.465a.7.7,0,0,0,.441,1.324l.477-.16v4.147a.7.7,0,1,0,1.395,0V9.125a.7.7,0,0,0-.755-.695Z"
			transform="translate(-4 -0.98)"
			fill="#fff"
		></path>
	</svg>
);

export const Forward: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18.596" height="20" viewBox="0 0 18.596 20">
		<path
			id="skip-ahead-15-seconds"
			d="M13.288.98a.93.93,0,0,0-.775,1.439A9.3,9.3,0,1,0,22.6,11.682a.93.93,0,1,0-1.86,0A7.438,7.438,0,1,1,12.46,4.294a.93.93,0,0,0,1.5,1.072L15.35,3.971a.93.93,0,0,0,0-1.315L13.956,1.262A.93.93,0,0,0,13.288.98Zm3.719,0a.93.93,0,0,0-.647,1.6l.737.737-.737.737a.93.93,0,1,0,1.315,1.315l1.395-1.395a.93.93,0,0,0,0-1.315L17.675,1.262A.93.93,0,0,0,17.007.98ZM14.156,8.428A.7.7,0,0,0,13.471,9l-.393,2.092a.7.7,0,0,0,.686.826h1.511a.814.814,0,0,1,.814.814c0,.672-.505.814-.93.814a2.107,2.107,0,0,1-1.2-.319.7.7,0,0,0-.864,1.1,3.409,3.409,0,0,0,2.063.617,2.169,2.169,0,0,0,2.324-2.208,2.211,2.211,0,0,0-2.208-2.208H14.6l.131-.7h1.818a.7.7,0,1,0,0-1.395Zm-3.008,0a.7.7,0,0,0-.163.033l-1.395.465a.7.7,0,0,0,.441,1.324l.477-.16v4.147a.7.7,0,0,0,1.395,0V9.125a.7.7,0,0,0-.755-.695Z"
			transform="translate(-4 -0.98)"
			fill="#fff"
		></path>
	</svg>
);

export const Mute: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22.444" height="20" viewBox="0 0 22.444 19.976">
		<path
			id="medium-volume"
			d="M18.132,7.1a1.728,1.728,0,0,0-.234.016,1.645,1.645,0,0,0-.875.4h0l-5.451,4.845H7.66A2.673,2.673,0,0,0,5,15.021v4.138a2.673,2.673,0,0,0,2.66,2.66h3.911l5.451,4.845a1.655,1.655,0,0,0,2.755-1.236V8.752a1.68,1.68,0,0,0-.977-1.51A1.644,1.644,0,0,0,18.132,7.1Zm6.821,2.884a.887.887,0,0,0-.784,1.308,11.722,11.722,0,0,1,0,11.593.887.887,0,1,0,1.572.82,13.706,13.706,0,0,0,0-13.232.887.887,0,0,0-.788-.488Zm-2.71,2.965a.887.887,0,0,0-.763,1.266,6.488,6.488,0,0,1,0,5.757.887.887,0,1,0,1.612.74,8.452,8.452,0,0,0,.006-7.235A.887.887,0,0,0,22.243,12.95Z"
			transform="translate(-5 -7.102)"
			fill="#fff"
		></path>
	</svg>
);

export const ShadowUnMute: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
		<g filter="url(#filter0_d_107_13)">
			<path d="M5.66282 4C5.02124 3.99935 4.50063 4.53562 4.5 5.1978C4.49969 5.52304 4.62741 5.83445 4.85387 6.06062L12.1617 13.6087H8.7815C6.85727 13.6118 5.29811 15.221 5.29511 17.2071V22.8042C5.29811 24.7902 6.85727 26.3995 8.7815 26.4026H13.9103L21.0547 32.9597C21.4488 33.3228 21.959 33.5231 22.4874 33.5219C22.7973 33.5222 23.1037 33.4541 23.3862 33.3223C24.1646 32.9667 24.6657 32.1698 24.6636 31.2913V26.5122L33.5158 35.6486C33.9697 36.1171 34.7056 36.1171 35.1596 35.6486C35.6135 35.1801 35.6135 34.4206 35.1596 33.9521L6.49628 4.36405C6.27757 4.1314 5.9769 4.00007 5.66282 4ZM22.471 6.4823C21.9471 6.48936 21.4435 6.6921 21.0533 7.05298L16.4665 11.2698L24.6636 19.7301V8.72284C24.6688 7.84086 24.1665 7.03978 23.3848 6.6833C23.0979 6.54889 22.7861 6.48032 22.471 6.4823ZM31.3586 10.418C30.7191 10.4713 30.2426 11.0496 30.2943 11.7097C30.3067 11.8682 30.3495 12.0225 30.4203 12.1638C32.8252 16.5189 33.0781 21.7956 31.1012 26.3744L32.8526 28.1821C35.4854 22.7644 35.3461 16.3523 32.4808 11.0618C32.2687 10.6338 31.8285 10.3789 31.364 10.4152L31.3586 10.418ZM27.9212 14.424C27.277 14.4459 26.772 15.0027 26.7932 15.6676C26.7983 15.8261 26.8336 15.9819 26.8971 16.1262C27.8445 18.1244 28.0212 20.4194 27.3915 22.547L29.2041 24.4178C30.4476 21.4383 30.377 18.0484 29.0107 15.1268C28.8175 14.6877 28.3883 14.4108 27.9212 14.424Z" fill="white"/>
		</g>
		<defs>
			<filter id="filter0_d_107_13" x="0.5" y="0" width="39" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
				<feOffset/>
				<feGaussianBlur stdDeviation="2"/>
				<feComposite in2="hardAlpha" operator="out"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_107_13"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_107_13" result="shape"/>
			</filter>
		</defs>
	</svg>
);

export const Unmute: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22.444" height="20" viewBox="0 0 22.765 22.765">
		<path
			id="no-audio"
			d="M4.828,3.984A.853.853,0,0,0,4.234,5.45L9.6,10.82H7.118a2.564,2.564,0,0,0-2.56,2.56v3.982a2.564,2.564,0,0,0,2.56,2.56h3.766l5.246,4.665a1.575,1.575,0,0,0,1.052.4,1.6,1.6,0,0,0,.66-.142A1.576,1.576,0,0,0,18.78,23.4V20l6.5,6.5a.853.853,0,1,0,1.207-1.207L5.44,4.243A.853.853,0,0,0,4.828,3.984ZM17.17,5.75a1.591,1.591,0,0,0-1.041.406l-3.368,3,6.019,6.019V7.344a1.576,1.576,0,0,0-.939-1.451A1.6,1.6,0,0,0,17.17,5.75Zm6.526,2.8a.853.853,0,0,0-.689,1.242,11.206,11.206,0,0,1,.5,10.11l1.286,1.286a13.009,13.009,0,0,0-.273-12.18A.849.849,0,0,0,23.7,8.548ZM21.172,11.4a.857.857,0,0,0-.752,1.211,6.243,6.243,0,0,1,.363,4.568l1.331,1.331a7.961,7.961,0,0,0-.142-6.61A.853.853,0,0,0,21.172,11.4Z"
			transform="translate(-3.975 -3.984)"
			fill="#fff"
		></path>
	</svg>
);

export const ShadowVolumeSmall = () => (
	<svg aria-hidden="true" width="34" height="36" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_d_3_154)">
			<path d="M22.0568 4C21.9489 3.99998 21.841 4.00748 21.7341 4.0224C21.2872 4.0827 20.8683 4.27764 20.5309 4.58224L13.0346 11.3717H7.65751C5.64136 11.3824 4.00976 13.0457 4 15.1002V20.8974C4.01051 22.9514 5.64189 24.6138 7.65751 24.6245H13.036L20.5323 31.414C21.4716 32.265 22.9101 32.179 23.7452 31.2218C24.1156 30.7974 24.3202 30.2492 24.3203 29.6813V6.31495C24.312 5.40415 23.7888 4.57994 22.977 4.19874C22.6874 4.06748 22.3738 3.99977 22.0568 4ZM27.71 12.1947C27.037 12.2242 26.515 12.8041 26.5439 13.4898C26.5509 13.656 26.5906 13.8191 26.6606 13.9694C27.8946 16.5115 27.8946 19.4946 26.6606 22.0367C26.3762 22.6589 26.6405 23.3982 27.2511 23.6881C27.8617 23.978 28.5872 23.7086 28.8717 23.0864C28.8736 23.0822 28.8755 23.078 28.8774 23.0738C30.3713 19.8663 30.3743 16.1451 28.8856 12.9351C28.6829 12.4664 28.2189 12.1725 27.7168 12.1947H27.71Z" fill="white"/>
		</g>
		<defs>
			<filter id="filter0_d_3_154" x="0" y="0" width="34" height="36" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
				<feOffset/>
				<feGaussianBlur stdDeviation="2"/>
				<feComposite in2="hardAlpha" operator="out"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_154"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_154" result="shape"/>
			</filter>
		</defs>
	</svg>
);

export const VolumeSmall = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" className="gobrain-volume-1" width="22.444" height="20" viewBox="0 0 18.925 20">
		<path
			id="low-volume"
			d="M21.147,7.1a1.73,1.73,0,0,0-.235.016,1.647,1.647,0,0,0-.876.4h0l-5.458,4.851H10.663A2.677,2.677,0,0,0,8,15.031v4.142a2.677,2.677,0,0,0,2.663,2.663h3.916l5.458,4.851a1.657,1.657,0,0,0,2.758-1.238V8.754a1.682,1.682,0,0,0-.978-1.512A1.646,1.646,0,0,0,21.147,7.1Zm4.116,5.855a.888.888,0,0,0-.764,1.268,6.5,6.5,0,0,1,0,5.764.888.888,0,1,0,1.614.741,8.462,8.462,0,0,0,.006-7.244.888.888,0,0,0-.851-.529Z"
			transform="translate(-8 -7.102)"
			fill="#fff"
		></path>
	</svg>
);

export const VolumeDecrease: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" id="Group_203" xmlns="http://www.w3.org/2000/svg" width="12.305" height="3.102" viewBox="0 0 12.305 3.102">
		<defs>
			<clipPath id="clip-path">
				<rect id="Rectangle_9973" width="12.305" height="3.102" fill="#fff"></rect>
			</clipPath>
		</defs>
		<g id="Group_200">
			<path id="Path_9003" d="M10.754,0h-9.2a1.551,1.551,0,0,0,0,3.1h9.2a1.551,1.551,0,0,0,0-3.1" fill="#fff"></path>
		</g>
	</svg>
);

export const VolumeIncrease: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12.487" height="12.487" viewBox="0 0 12.487 12.487">
		<path
			id="Path_9004"
			d="M10.913,4.67h-3.1v-3.1a1.574,1.574,0,0,0-3.148,0v3.1h-3.1a1.574,1.574,0,0,0,0,3.148h3.1v3.1a1.574,1.574,0,0,0,3.148,0v-3.1h3.1a1.574,1.574,0,0,0,0-3.148"
			transform="translate(0 0)"
			fill="#fff"
		></path>
	</svg>
);

export const Heart = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.87" height="20" viewBox="0 0 361.84 310.11">
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path
					id="Icon_3"
					data-name="Icon 3"
					fill="#fff"
					d="M265.09.17A80.52,80.52,0,0,0,239.58,4.5a103.12,103.12,0,0,0-24.21,11.71c-7.44,4.92-13.89,9.54-19.24,13.81a197.55,197.55,0,0,0-15.32,13.74A197.23,197.23,0,0,0,165.48,30c-5.35-4.33-11.8-8.89-19.24-13.81A102.91,102.91,0,0,0,122.07,4.5,80.64,80.64,0,0,0,96.54.17a96.83,96.83,0,0,0-70.79,25A92.7,92.7,0,0,0,.15,94.61a87.57,87.57,0,0,0,4.72,27.83,123.19,123.19,0,0,0,10.77,24.39,174.85,174.85,0,0,0,13.75,19.66c5.14,6.37,8.82,10.78,11.2,13.24A62.46,62.46,0,0,0,46.16,185L172,306.48a12.71,12.71,0,0,0,17.77,0l125.66-121a131.85,131.85,0,0,0,46.21-90.81,92.69,92.69,0,0,0-25.43-69.45A97.46,97.46,0,0,0,265.09.17Z"
				/>
			</g>
		</g>
	</svg>
);

export const CloseChat: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.87" height="20" viewBox="0 0 18.937 20.039">
		<g transform="translate(-918.64 233.413)">
			<path
				fill="#fff"
				d="M924.508-224.8a1.117,1.117,0,0,1-1.117,1.117,1.117,1.117,0,0,1-1.117-1.117,1.116,1.116,0,0,1,1.117-1.117,1.116,1.116,0,0,1,1.117,1.117Zm4.467,0a1.117,1.117,0,0,1-1.117,1.117,1.117,1.117,0,0,1-1.117-1.117,1.116,1.116,0,0,1,1.117-1.117h0a1.116,1.116,0,0,1,1.117,1.117h0Zm4.467,0a1.117,1.117,0,0,1-1.117,1.117,1.117,1.117,0,0,1-1.117-1.117,1.116,1.116,0,0,1,1.117-1.117h0a1.116,1.116,0,0,1,1.117,1.117h0Z"
				transform="translate(0.25 0.514)"
			/>
			<path
				fill="#fff"
				d="M937.043-213.374a.533.533,0,0,1-.389-.168l-17.869-18.97a.535.535,0,0,1,.022-.756.535.535,0,0,1,.756.022l17.869,18.97a.535.535,0,0,1-.022.755A.534.534,0,0,1,937.043-213.374Z"
				transform="translate(0 0)"
			/>
			<g transform="translate(919.174 -230.987)">
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M924.232-230.026H934.5a1.116,1.116,0,0,1,1.117,1.117v8.939a1.1,1.1,0,0,1-.9,1.072l.833.884a2.224,2.224,0,0,0,1.184-1.96v-8.935a2.233,2.233,0,0,0-2.234-2.233H923.181Z"
					transform="translate(-918.863 231.143)"
				/>
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M932.1-218.862H924.07a2.227,2.227,0,0,0-1.579.652l-2.233,2.233v-12.941a1.116,1.116,0,0,1,1.117-1.117h.2l-.929-.985a2.226,2.226,0,0,0-1.506,2.1v14.288a.56.56,0,0,0,.56.558.559.559,0,0,0,.394-.164l3.187-3.187a1.117,1.117,0,0,1,.79-.327h9.075Z"
					transform="translate(-919.14 231.151)"
				/>
			</g>
		</g>
	</svg>
);

export const ShowChat: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.87" height="20" viewBox="0 0 12.227 11.687">
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M0,1.528A1.528,1.528,0,0,1,1.528,0H10.7a1.528,1.528,0,0,1,1.528,1.528V7.642A1.528,1.528,0,0,1,10.7,9.17H3.373a.764.764,0,0,0-.54.224l-2.18,2.18A.382.382,0,0,1,0,11.3ZM3.821,4.585a.764.764,0,1,1-.764-.764A.764.764,0,0,1,3.821,4.585Zm3.057,0a.764.764,0,1,1-.764-.764A.764.764,0,0,1,6.878,4.585Zm2.293.764a.764.764,0,1,0-.764-.764A.764.764,0,0,0,9.17,5.349Z"
		/>
	</svg>
);

export const ShoppingCart: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.87" height="20" viewBox="0 0 341.77 324.56">
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path
					d="M290.4,256.23H93.1l-3.42-25.62h217.8a8.54,8.54,0,0,0,8.54-7.26L341.64,61.07a7.67,7.67,0,0,0-2.13-6.83,8.91,8.91,0,0,0-6.41-3H65.77l-6-44A8.54,8.54,0,0,0,51.25,0H8.54a8.54,8.54,0,0,0,0,17.08h35L76,257.94A33.31,33.31,0,0,0,51.25,290.4a34.17,34.17,0,0,0,68.33,0,32.9,32.9,0,0,0-4.7-17.08H260.93a32.9,32.9,0,0,0-4.7,17.08,34.17,34.17,0,1,0,34.17-34.17Z"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
);

export const LanguageSetting: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.87" height="20" viewBox="0 0 20.87 20">
		<path
			id="chat-square-text-fill"
			d="M0,2.609A2.609,2.609,0,0,1,2.609,0H18.261A2.609,2.609,0,0,1,20.87,2.609V13.044a2.609,2.609,0,0,1-2.609,2.609H15a1.3,1.3,0,0,0-1.044.522l-2.478,3.3a1.3,1.3,0,0,1-2.087,0l-2.478-3.3a1.3,1.3,0,0,0-1.044-.522H2.609A2.609,2.609,0,0,1,0,13.044Zm4.565,1.3a.652.652,0,0,0,0,1.3H16.3a.652.652,0,1,0,0-1.3Zm0,3.261a.652.652,0,0,0,0,1.3H16.3a.652.652,0,1,0,0-1.3Zm0,3.261a.652.652,0,0,0,0,1.3h6.522a.652.652,0,0,0,0-1.3Z"
			fill="#fff"
		></path>
	</svg>
);

export const Settings = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="19.046" height="20" viewBox="0 0 19.046 20">
		<path
			id="settings"
			d="M22.047,15.142a1.394,1.394,0,0,1,0-2.248l1.647-1.208a.751.751,0,0,0,.269-.842A9.937,9.937,0,0,0,21.969,7.39.752.752,0,0,0,21.1,7.2l-1.855.816A1.394,1.394,0,0,1,17.3,6.892l-.223-2.036a.751.751,0,0,0-.6-.654A10.075,10.075,0,0,0,12.5,4.2a.749.749,0,0,0-.6.654l-.221,2.023A1.395,1.395,0,0,1,9.734,8L7.87,7.179a.75.75,0,0,0-.863.189,9.932,9.932,0,0,0-2,3.448.751.751,0,0,0,.268.844l1.637,1.2a1.394,1.394,0,0,1,0,2.248L5.261,16.315a.751.751,0,0,0-.269.842,9.937,9.937,0,0,0,1.994,3.455.75.75,0,0,0,.864.19L9.7,19.986a1.394,1.394,0,0,1,1.947,1.124l.223,2.036a.751.751,0,0,0,.6.654,10.033,10.033,0,0,0,3.984,0,.749.749,0,0,0,.6-.654l.222-2.023A1.395,1.395,0,0,1,19.221,20l1.865.82a.749.749,0,0,0,.863-.189,9.932,9.932,0,0,0,2-3.448.751.751,0,0,0-.268-.844ZM14.478,17.5a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,14.478,17.5Z"
			transform="translate(-4.955 -4.001)"
			fill="#fff"
		></path>
	</svg>
);

export const FullScreen: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.001" height="20" viewBox="0 0 20.001 20">
		<path
			id="full-screen"
			d="M9.055,6A3.072,3.072,0,0,0,6,9.055v3.056a1.111,1.111,0,1,0,2.222,0V9.055a.822.822,0,0,1,.833-.833H12.11A1.111,1.111,0,1,0,12.11,6ZM19.888,6a1.111,1.111,0,1,0,0,2.222h3.056a.822.822,0,0,1,.833.833v3.056a1.111,1.111,0,1,0,2.222,0V9.055A3.072,3.072,0,0,0,22.943,6ZM7.094,18.762A1.111,1.111,0,0,0,6,19.889v3.056A3.072,3.072,0,0,0,9.055,26H12.11a1.111,1.111,0,1,0,0-2.222H9.055a.822.822,0,0,1-.833-.833V19.889a1.111,1.111,0,0,0-1.127-1.126Zm17.778,0a1.111,1.111,0,0,0-1.095,1.126v3.056a.822.822,0,0,1-.833.833H19.888a1.111,1.111,0,1,0,0,2.222h3.056A3.072,3.072,0,0,0,26,22.944V19.889a1.111,1.111,0,0,0-1.127-1.126Z"
			transform="translate(-5.998 -6)"
			fill="#fff"
		></path>
	</svg>
);

export const ExitFullScreen: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g id="Group_177" data-name="Group 177" transform="translate(-1311 -713)">
			<rect id="Rectangle_68" width="45" height="45" rx="4" transform="translate(1311 713)" fill="#126cfc" opacity="0"></rect>
			<path
				id="normal-screen"
				d="M12.089,5.973A1.11,1.11,0,0,0,11,7.1v3.053a.821.821,0,0,1-.833.833H7.108a1.11,1.11,0,1,0,0,2.221h3.053a3.07,3.07,0,0,0,3.053-3.053V7.1a1.11,1.11,0,0,0-1.127-1.125Zm7.772,0A1.11,1.11,0,0,0,18.768,7.1v3.053A3.07,3.07,0,0,0,21.82,13.2h3.053a1.11,1.11,0,1,0,0-2.221H21.82a.821.821,0,0,1-.833-.833V7.1a1.11,1.11,0,0,0-1.128-1.125ZM7.109,18.755a1.11,1.11,0,1,0,0,2.221h3.053a.821.821,0,0,1,.833.833v3.053a1.11,1.11,0,1,0,2.221,0V21.809a3.07,3.07,0,0,0-3.053-3.053Zm14.711,0a3.07,3.07,0,0,0-3.053,3.053v3.053a1.11,1.11,0,1,0,2.221,0V21.809a.821.821,0,0,1,.833-.833h3.053a1.11,1.11,0,1,0,0-2.221Z"
				transform="translate(1317.509 719.528)"
				fill="#fff"
			></path>
		</g>
	</svg>
);

export const Send: React.FC<QPlayerSVGElementProps> = ({ onClick, color }) => {
	return (
		<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" onClick={onClick}>
			<g id="Group_8027" data-name="Group 8027" transform="translate(0.21 0.11)">
				<rect
					id="Rectangle_63"
					data-name="Rectangle 63"
					width="34"
					height="34"
					rx="4"
					transform="translate(-0.21 -0.11)"
					fill="rgba(18,108,252,0)"
				/>
				<path
					id="cursor-fill"
					d="M16.255,2.205a.58.58,0,0,1,.119.646L9.813,17.616a.58.58,0,0,1-1.064-.008L6.381,12.079.851,9.711A.58.58,0,0,1,.844,8.648L15.609,2.086a.58.58,0,0,1,.645.119Z"
					transform="translate(8.327 6.892)"
					fill={color ?? '#fff'}
					fillRule="evenodd"
				/>
			</g>
		</svg>
	);
};

export const UpIcon: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" id="chevron_drop_up" data-name="chevron drop up" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<rect id="Boundary" width="20" height="20" fill="none" />
		<path id="_Color" data-name=" ↳Color" d="M5,0,0,5,1.175,6.175,5,2.358,8.825,6.175,10,5Z" transform="translate(5 6.913)" fill={color} />
	</svg>
);

export const DownIcon: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style={{ transform: 'rotate(180deg)' }}>
		<rect id="Boundary" width="20" height="20" fill="none" />
		<path id="_Color" data-name=" ↳Color" d="M5,0,0,5,1.175,6.175,5,2.358,8.825,6.175,10,5Z" transform="translate(5 6.913)" />
	</svg>
);

export const PinIcon: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" height="10px" strokeMiterlimit="10" version="1.1" viewBox="0 0 8.818 8.9" width="10px" xmlns="http://www.w3.org/2000/svg">
		<defs />
		<clipPath id="ArtboardFrame">
			<rect height="8.9" width="8.818" x="0" y="0" />
		</clipPath>
		<g clipPath="url(#ArtboardFrame)" id="Group-243">
			<path
				d="M6.149 0C6.21732 0.0230766 6.27813 0.0641937 6.325 0.119C7.107 0.9 7.887 1.689 8.676 2.466C8.895 2.682 8.848 2.84 8.618 2.987C8.39028 3.14198 8.09788 3.1659 7.848 3.05C7.83102 3.03776 7.80969 3.03318 7.78918 3.03736C7.76867 3.04154 7.75084 3.0541 7.74 3.072C7.02667 3.906 6.31133 4.739 5.594 5.571C5.559 5.611 5.565 5.632 5.594 5.671C5.93235 6.09892 5.89846 6.71198 5.515 7.1C5.46998 7.15471 5.40285 7.1864 5.332 7.1864C5.26115 7.1864 5.19402 7.15471 5.149 7.1C4.70767 6.66 4.26733 6.219 3.828 5.777C3.779 5.728 3.756 5.721 3.702 5.777C3.058 6.416 2.432 7.077 1.762 7.686C1.323 8.086 0.862 8.46 0.399 8.834C0.337594 8.90135 0.242215 8.92608 0.155818 8.89707C0.0694221 8.86805 0.00830783 8.79076-3.34063e-09 8.7C-0.00840026 8.6267 0.016139 8.55345 0.067 8.5C0.613272 7.8015 1.19783 7.13381 1.818 6.5C2.25133 6.06467 2.68467 5.63133 3.118 5.2C3.175 5.143 3.166 5.119 3.118 5.068C2.65933 4.61267 2.20133 4.15467 1.744 3.694C1.67317 3.647 1.63134 3.56701 1.63317 3.48202C1.63499 3.39704 1.68022 3.31891 1.753 3.275C2.14223 2.91832 2.73275 2.89671 3.147 3.224C3.194 3.261 3.217 3.257 3.259 3.224C4.08633 2.50733 4.91767 1.793 5.753 1.081C5.77004 1.07146 5.78232 1.05524 5.78688 1.03625C5.79144 1.01726 5.78786 0.997233 5.777 0.981C5.63473 0.674858 5.69995 0.31236 5.94 0.0749999C5.9765 0.0437842 6.01767 0.0184776 6.062 1.05684e-08L6.149 0Z"
				fill="currentColor"
				fillRule="evenodd"
				opacity="1"
				stroke="none"
			/>
		</g>
	</svg>
);

export const Poll: React.FC<QPlayerSVGElementProps> = (props) => (
	<svg aria-hidden="true"
		xmlns="http://www.w3.org/2000/svg"
		width={isUsedOnMobile(queryParams) ? '12' : '15'}
		height={isUsedOnMobile(queryParams) ? '12' : '19'}
		viewBox="0 0 15 15"
	>
		<path
			id="Path_9855"
			data-name="Path 9855"
			d="M450.152,745.119h-11.86a1.571,1.571,0,0,0-1.57,1.571v11.859a1.57,1.57,0,0,0,1.57,1.57h11.86a1.57,1.57,0,0,0,1.57-1.57V746.69A1.571,1.571,0,0,0,450.152,745.119Zm-8.073,11.786a.714.714,0,0,1-.714.714h-1.429a.714.714,0,0,1-.714-.714v-2.143a.714.714,0,0,1,.714-.714h1.429a.714.714,0,0,1,.714.714Zm3.571,0a.713.713,0,0,1-.714.714h-1.428a.714.714,0,0,1-.715-.714v-5a.715.715,0,0,1,.715-.714h1.428a.714.714,0,0,1,.714.714Zm3.572,0a.714.714,0,0,1-.714.714h-1.429a.714.714,0,0,1-.714-.714v-8.571a.715.715,0,0,1,.714-.715h1.429a.715.715,0,0,1,.714.715Z"
			transform="translate(-436.722 -745.119)"
			fill={props.color ?? '#0c306c'}
		/>
	</svg>
);

export const ShadowClose: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_d_3_165)">
			<path d="M6 24L4 22L12 14L4 6L6 4L14 12L22 4L24 6L16 14L24 22L22 24L14 16L6 24Z" fill={color ?? "#fff"}/>
		</g>
		<defs>
			<filter id="filter0_d_3_165" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
				<feOffset/>
				<feGaussianBlur stdDeviation="2"/>
				<feComposite in2="hardAlpha" operator="out"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_165"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_165" result="shape"/>
			</filter>
		</defs>
	</svg>
);

export const Close: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 6.961 6.96" fill={color}>
		<path
			fill={color}
			id="Close"
			d="M399.142,170.356l-1.759,1.759-1.762-1.76a1.007,1.007,0,1,0-1.423,1.424l1.76,1.76L394.2,175.3a1.008,1.008,0,0,0,1.425,1.426l1.76-1.759,1.76,1.76a1.007,1.007,0,1,0,1.424-1.423l-1.76-1.761,1.759-1.759a1.008,1.008,0,0,0-1.425-1.425Z"
			transform="translate(-393.902 -170.059)"
		/>
	</svg>
);

export const CloseChatBlackBG: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
		<g id="Group_8061" data-name="Group 8061" transform="translate(0.21 0.11)">
			<rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
			<g id="Group_7976" data-name="Group 7976" transform="translate(-910.07 240.788)">
				<path
					id="Path_533"
					data-name="Path 533"
					d="M924.214-224.948a.97.97,0,0,1-.969.969.97.97,0,0,1-.97-.969.969.969,0,0,1,.97-.969.969.969,0,0,1,.969.969Zm3.877,0a.969.969,0,0,1-.969.969.97.97,0,0,1-.969-.969.969.969,0,0,1,.969-.969h0a.969.969,0,0,1,.969.969h0Zm3.878,0a.97.97,0,0,1-.969.969.969.969,0,0,1-.969-.969.969.969,0,0,1,.969-.969h0a.969.969,0,0,1,.969.969h0Z"
					transform="translate(-0.263 -0.542)"
					fill="#fff"
				/>
				<path
					id="Path_1475"
					data-name="Path 1475"
					d="M934.615-216.018a.463.463,0,0,1-.338-.146l-15.511-16.468a.464.464,0,0,1,.019-.656.465.465,0,0,1,.656.02L934.953-216.8a.464.464,0,0,1-.019.656A.464.464,0,0,1,934.615-216.018Z"
					transform="translate(0 0)"
					fill="#fff"
				/>
				<g id="Group_225" data-name="Group 225" transform="translate(919.104 -231.307)">
					<path
						id="Path_1476"
						data-name="Path 1476"
						d="M924.094-230.174H933a.969.969,0,0,1,.969.969v7.76a.954.954,0,0,1-.781.93l.723.767a1.931,1.931,0,0,0,1.028-1.7V-229.2A1.939,1.939,0,0,0,933-231.143h-9.824Z"
						transform="translate(-919.432 231.143)"
						fill="#fff"
						fillRule="evenodd"
					/>
					<path
						id="Path_1477"
						data-name="Path 1477"
						d="M930.389-220.466h-6.969a1.933,1.933,0,0,0-1.371.566l-1.939,1.939V-229.2a.969.969,0,0,1,.969-.969h.175l-.806-.855a1.932,1.932,0,0,0-1.307,1.825v12.4a.486.486,0,0,0,.486.484.485.485,0,0,0,.342-.142l2.766-2.766a.97.97,0,0,1,.685-.284H931.3Z"
						transform="translate(-919.14 231.134)"
						fill="#fff"
						fillRule="evenodd"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const ChatBlackBG = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
		<g id="Group_8028" data-name="Group 8028" transform="translate(0.21 0.11)">
			<rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
			<path
				id="chat-left-dots-fill"
				d="M0,1.938A1.937,1.937,0,0,1,1.938,0H13.562A1.938,1.938,0,0,1,15.5,1.938v7.75a1.938,1.938,0,0,1-1.938,1.938H4.276a.969.969,0,0,0-.685.284L.827,14.673A.484.484,0,0,1,0,14.331ZM4.844,5.813a.969.969,0,1,1-.969-.969A.969.969,0,0,1,4.844,5.813Zm3.875,0a.969.969,0,1,1-.969-.969A.969.969,0,0,1,8.719,5.813Zm2.906.969a.969.969,0,1,0-.969-.969A.969.969,0,0,0,11.625,6.781Z"
				transform="translate(9.04 9.483)"
				fill="#fff"
				fillRule="evenodd"
			/>
		</g>
	</svg>
);

export const CartBlackBG: React.FC<QPlayerSVGElementProps> = (props) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
		<g id="Group_8025" data-name="Group 8025" transform="translate(0.21 0.11)">
			<rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
			<path
				id="shopping_cart_buy_commerce"
				data-name="shopping, cart, buy, commerce"
				d="M18.332,20.881H9.954l-.145-1.088h9.249a.363.363,0,0,0,.363-.308l1.088-6.892a.326.326,0,0,0-.091-.29.381.381,0,0,0-.272-.127H8.793l-.254-1.868A.363.363,0,0,0,8.176,10H6.363a.363.363,0,1,0,0,.725H7.85L9.228,20.954a1.415,1.415,0,0,0-1.052,1.378,1.451,1.451,0,0,0,2.9,0,1.4,1.4,0,0,0-.2-.725h6.2a1.4,1.4,0,0,0-.2.725,1.451,1.451,0,1,0,1.451-1.451Z"
				transform="translate(3.533 -0.001)"
				fill="#fff"
			/>
			<g id="Group_8015" data-name="Group 8015" transform="translate(-1201.425 -595.518)">
				<rect
					id="Rectangle_8712"
					data-name="Rectangle 8712"
					width="16.121"
					height="17"
					rx="8.061"
					transform="translate(1219.093 596)"
					fill="#126cfc"
				/>
				<text
					id="_2"
					data-name="2"
					transform="translate(1227.154 609)"
					fill="#fff"
					fontSize="12"
					fontFamily="inherit"
					fontWeight="500"
					letterSpacing="0.02em"
				>
					<tspan x="-3" y="0">
						{props.text ?? 2}
					</tspan>
				</text>
			</g>
		</g>
	</svg>
);

export const HeartBlackBG: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
		<g id="Group_8026" data-name="Group 8026" transform="translate(0.21 0.11)">
			<rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
			<path
				id="Icon_3"
				data-name="Icon 3"
				d="M13.292.57a3.9,3.9,0,0,0-1.235.21,4.974,4.974,0,0,0-1.172.567c-.36.238-.672.462-.931.668a9.569,9.569,0,0,0-.742.665,9.569,9.569,0,0,0-.742-.665c-.259-.21-.57-.43-.931-.668A4.974,4.974,0,0,0,6.367.78,3.9,3.9,0,0,0,5.132.57,4.685,4.685,0,0,0,1.707,1.781,4.485,4.485,0,0,0,.468,5.14,4.243,4.243,0,0,0,.7,6.487a5.951,5.951,0,0,0,.521,1.183,8.478,8.478,0,0,0,.665.952c.248.308.427.521.542.64s.2.2.269.255l6.092,5.878a.586.586,0,0,0,.43.175.6.6,0,0,0,.43-.175l6.081-5.857a6.38,6.38,0,0,0,2.236-4.395,4.485,4.485,0,0,0-1.239-3.359A4.715,4.715,0,0,0,13.292.57Z"
				transform="translate(7.572 8.82)"
				fill="#fff"
			/>
		</g>
	</svg>
);

export const ShareBlackBG: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
		<g id="Group_8033" data-name="Group 8033" transform="translate(-1056 -703)">
			<rect id="Rectangle_28" data-name="Rectangle 28" width="34" height="34" rx="4" transform="translate(1056 703)" />
			<path
				id="share"
				d="M17.515,5a2.582,2.582,0,0,0-2.489,3.261l-.046.023L9.664,10.941l-.046.023a2.581,2.581,0,1,0,0,3.171l.044.023,5.317,2.658.043.022A2.592,2.592,0,1,0,15.6,15.79l-.084-.042L10.2,13.09l-.083-.041a2.582,2.582,0,0,0,0-1l.084-.042,5.316-2.658.081-.041A2.582,2.582,0,1,0,17.515,5Z"
				transform="translate(1060.436 707.436)"
				fill="#fff"
			/>
		</g>
	</svg>
);

export const ShadowShare: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_d_3_156)">
			<path d="M25.53 4C23.0768 4.00074 21.0887 5.98996 21.0894 8.443C21.0895 8.83637 21.1419 9.228 21.2452 9.60758L21.166 9.64648L12.025 14.2179L11.9458 14.2569C10.4398 12.3214 7.64985 11.9729 5.71414 13.4787C3.77843 14.9846 3.43002 17.7744 4.93594 19.71C6.44187 21.6455 9.23185 21.9939 11.1676 20.4881C11.4582 20.262 11.7196 20.0006 11.9458 19.71L12.0224 19.7489L21.1686 24.3203L21.2439 24.358C20.5901 26.7312 21.9842 29.1851 24.3576 29.8388C26.7311 30.4925 29.1851 29.0985 29.8388 26.7253C30.4926 24.352 29.0985 21.8982 26.7251 21.2445C25.0986 20.7965 23.3585 21.3051 22.2294 22.5585L22.0853 22.4858L12.9404 17.9144L12.7975 17.8442C12.9097 17.2763 12.9097 16.6919 12.7975 16.1239L12.9417 16.0513L22.0866 11.4797L22.2268 11.4097C23.8661 13.2346 26.6745 13.3853 28.4996 11.7461C30.3247 10.1069 30.4753 7.29859 28.836 5.47363C27.9932 4.53537 26.7913 3.9996 25.53 4Z" fill={color ?? "#fff"}/>
		</g>
		<defs>
			<filter id="filter0_d_3_156" x="0" y="0" width="34" height="34" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
				<feOffset/>
				<feGaussianBlur stdDeviation="2"/>
				<feComposite in2="hardAlpha" operator="out"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_156"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_156" result="shape"/>
			</filter>
		</defs>
	</svg>
);

export const Share: React.FC<QPlayerSVGElementProps> = () => (
	<svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="52" height="44" viewBox="0 0 52 44">
		<g transform="translate(-1056 -707)">
			<g fill={'rgba(255, 255, 255, 0.21)'} stroke-sharing="#fff" transform="translate(1056 707)" style={{ opacity: '0' }}>
				<rect stroke-sharing="none" width="52" height="44" rx="4" />
				<rect x="0.5" y="0.5" width="51" height="43" rx="3.5" />
			</g>
			<path
				fill={'#fff'}
				d="M17.894,20.518l9.552-6.861a1.5,1.5,0,0,0,0-2.589L17.894,4.208A1.5,1.5,0,0,0,15.637,5.5V8.181C12.5,8.181,
3.091,8.181,1,24.909a15.572,15.572,0,0,1,14.637-8.364v2.679a1.5,1.5,0,0,0,2.256,1.3Z"
				transform="translate(1067.587 714.642)"
			/>
		</g>
	</svg>
);

export const Minus: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
		<g id="Group_8062" data-name="Group 8062" transform="translate(-134 -243)">
			<rect id="Rectangle_9780" data-name="Rectangle 9780" width="22" height="22" rx="2" transform="translate(134 243)" fill="#126cfc" />
			<g id="x" transform="translate(144.853 248.707) rotate(45)">
				<path
					id="Path_1418"
					data-name="Path 1418"
					d="M11.838,4.146a.5.5,0,0,1,0,.707L4.852,11.838a.5.5,0,1,1-.707-.707l6.986-6.986a.5.5,0,0,1,.707,0Z"
					transform="translate(-3.999 -3.999)"
					fill="#fff"
					fillRule="evenodd"
				/>
			</g>
		</g>
	</svg>
);

export const Plus = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
		<g id="Group_8063" data-name="Group 8063" transform="translate(-221 -243)">
			<rect id="Rectangle_9781" data-name="Rectangle 9781" width="22" height="22" rx="2" transform="translate(221 243)" fill="#126cfc" />
			<g id="x" transform="translate(232 247.009) rotate(45)">
				<path
					id="Path_1418"
					data-name="Path 1418"
					d="M9.705.182a.618.618,0,0,1,0,.875L1.056,9.706a.619.619,0,1,1-.875-.875L8.83.182a.618.618,0,0,1,.875,0Z"
					transform="translate(0)"
					fill="#fff"
					fillRule="evenodd"
				/>
				<path
					id="Path_1419"
					data-name="Path 1419"
					d="M.182.182a.618.618,0,0,0,0,.875L8.831,9.706a.619.619,0,1,0,.875-.875L1.056.182a.618.618,0,0,0-.875,0Z"
					fill="#fff"
					fillRule="evenodd"
				/>
			</g>
		</g>
	</svg>
);

export const DownWithBG: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
		<g id="Group_8058" data-name="Group 8058" transform="translate(-150 -574)">
			<circle id="Ellipse_1768" data-name="Ellipse 1768" cx="18" cy="18" r="18" transform="translate(150 574)" fill="#1c1b1b" />
			<g id="chevron_drop_up" data-name="chevron drop up" transform="translate(178 602) rotate(180)">
				<rect id="Boundary" width="20" height="20" fill="none" />
				<path id="_Color" data-name=" ↳Color" d="M5,0,0,5,1.175,6.175,5,2.358,8.825,6.175,10,5Z" transform="translate(5 6.913)" fill="#fff" />
			</g>
		</g>
	</svg>
);

export const UpWithBG: React.FC<QPlayerSVGElementProps> = () => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
		<g id="Group_8058" data-name="Group 8058" transform="translate(-150 -574)">
			<circle id="Ellipse_1768" data-name="Ellipse 1768" cx="18" cy="18" r="18" transform="translate(150 574)" fill="#1c1b1b" />
			<g id="chevron_drop_up" data-name="chevron drop up" transform="">
				<rect id="Boundary" width="20" height="20" fill="none" />
				<path id="_Color" data-name=" ↳Color" d="M5,0,0,5,1.175,6.175,5,2.358,8.825,6.175,10,5Z" transform="translate(5 6.913)" fill="#fff" />
			</g>
		</g>
	</svg>
);

export const ArrowBack: React.FC<QPlayerSVGElementProps> = ({ color, width, height }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width={width ?? "22"} height={height ?? "22"} viewBox="0 0 22 22">
		<path
			id="arrow-down"
			d="M13.691,4h2.778V20.667l7.639-7.639L26.08,15l-11,11-11-11,1.972-1.972,7.639,7.639Z"
			transform="translate(26 -4.08) rotate(90)"
			fill={color ?? '#ffffff'}
		/>
	</svg>
);

export const Question: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
		<path
			id="question-square-fill"
			d="M1.875,0A1.875,1.875,0,0,0,0,1.875v11.25A1.875,1.875,0,0,0,1.875,15h11.25A1.875,1.875,0,0,0,15,13.125V1.875A1.875,1.875,0,0,0,13.125,0ZM6.159,5.656H4.922A2.3,2.3,0,0,1,7.506,3.281c1.31,0,2.506.684,2.506,2.1A2.288,2.288,0,0,1,8.845,7.31C8.154,7.834,7.9,8.03,7.9,8.7v.333H6.672L6.666,8.6A2.135,2.135,0,0,1,7.761,6.739c.553-.416.9-.69.9-1.285a1.089,1.089,0,0,0-1.232-1.1,1.2,1.2,0,0,0-1.273,1.3ZM7.332,11.7a.878.878,0,1,1,0-1.75.879.879,0,1,1,0,1.75Z"
			fill={color ?? '#0c306c'}
			fillRule="evenodd"
		/>
	</svg>
);

export const Previous = () => (
	<svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="white" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.509 28H11.2567C11.9383 28 12.4909 27.4635 12.4909 26.8017L12.4909 13.1983C12.4909 12.5365 11.9383 12 11.2567 12H10.509C9.8274 12 9.27485 12.5365 9.27485 13.1983L9.27485 26.8017C9.27485 27.4635 9.8274 28 10.509 28Z" />
		<path d="M28.9033 27.9986C29.9075 27.9635 30.7079 27.1716 30.7252 26.196V13.7981C30.7071 12.7877 29.8488 11.9827 28.8081 12.0003C28.5107 12.0053 28.2188 12.0786 27.9562 12.2142L16.4307 18.4119C15.5299 18.9192 15.2232 20.0394 15.7457 20.914C15.9104 21.1899 16.1466 21.4191 16.4307 21.5791L27.9562 27.7792C28.245 27.9356 28.5728 28.0115 28.9033 27.9986Z" />
	</svg>
);

export const Next = () => (
	<svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="white" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.0967 12.0014C10.0925 12.0365 9.29214 12.8284 9.27484 13.804V26.2019C9.2929 27.2123 10.1512 28.0173 11.1919 27.9997C11.4893 27.9947 11.7812 27.9214 12.0439 27.7858L23.5693 21.5881C24.4701 21.0808 24.7768 19.9606 24.2543 19.086C24.0896 18.8101 23.8534 18.5809 23.5693 18.4209L12.0439 12.2208C11.755 12.0644 11.4272 11.9885 11.0967 12.0014Z" />
		<path d="M29.491 12H28.7433C28.0617 12 27.5091 12.5365 27.5091 13.1983V26.8017C27.5091 27.4635 28.0617 28 28.7433 28H29.491C30.1726 28 30.7252 27.4635 30.7252 26.8017V13.1983C30.7252 12.5365 30.1726 12 29.491 12Z" />
	</svg>
);

export const Expand = () => (
	<svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="white" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.9998 26.5C19.6386 26.5 19.2774 26.3612 19.0016 26.0836L8.91361 15.9265C8.36213 15.3716 8.36213 14.4714 8.91361 13.9164C9.46441 13.3612 10.3592 13.3612 10.91 13.9164L19.9998 23.0682L29.09 13.9164C29.6408 13.3612 30.5349 13.3612 31.0864 13.9164C31.6379 14.4714 31.6379 15.3716 31.0864 15.9265L20.998 26.0836C20.7226 26.3612 20.361 26.5 19.9998 26.5Z" />
	</svg>
);

export const Collapse = () => (
	<svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="white" xmlns="http://www.w3.org/2000/svg">
		<path d="M20.0002 13.5C20.3614 13.5 20.7226 13.6388 20.9984 13.9164L31.0864 24.0735C31.6379 24.6284 31.6379 25.5286 31.0864 26.0836C30.5356 26.6388 29.6408 26.6388 29.09 26.0836L20.0002 16.9318L10.91 26.0836C10.3592 26.6388 9.4651 26.6388 8.91361 26.0836C8.36213 25.5286 8.36213 24.6284 8.91361 24.0735L19.002 13.9164C19.2774 13.6388 19.639 13.5 20.0002 13.5Z" />
	</svg>
);

export const Recommend: React.FC<QPlayerSVGElementProps> = ({}) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.845" height="20.845" viewBox="0 0 20.845 20.845">
		<path
			id="recommend_FILL0_wght400_GRAD0_opsz48"
			d="M87.3,192h5.993a1.125,1.125,0,0,0,.612-.156,1.332,1.332,0,0,0,.43-.469l2.032-4.742a1.864,1.864,0,0,0,.091-.391,2.892,2.892,0,0,0,.039-.391v-.625a.609.609,0,0,0-.7-.7H90.214l.756-3.6a.745.745,0,0,0,0-.391.711.711,0,0,0-.182-.313l-.547-.573-4.2,4.534-.208.417a.977.977,0,0,0-.1.443v5.394a1.515,1.515,0,0,0,.469,1.081A1.481,1.481,0,0,0,87.3,192Zm3.127,4.846a10.085,10.085,0,0,1-4.039-.821,10.5,10.5,0,0,1-5.563-5.563,10.411,10.411,0,0,1,0-8.1,10.416,10.416,0,0,1,2.241-3.309,10.684,10.684,0,0,1,3.322-2.228,10.411,10.411,0,0,1,8.1,0,10.406,10.406,0,0,1,5.537,5.537,10.411,10.411,0,0,1,0,8.1,10.684,10.684,0,0,1-2.228,3.322,10.416,10.416,0,0,1-3.309,2.241A10.149,10.149,0,0,1,90.422,196.845Zm0-1.563a8.852,8.852,0,1,0-6.266-2.593A8.525,8.525,0,0,0,90.422,195.281ZM90.422,186.422Z"
			transform="translate(-80 -176)"
			fill="#aaafb2"
		/>
	</svg>
);

export const Recommended: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20.845" height="20.845" viewBox="0 0 20.845 20.845">
		<path
			id="recommend_FILL0_wght400_GRAD0_opsz48"
			d="M87.3,192h5.993a1.125,1.125,0,0,0,.612-.156,1.332,1.332,0,0,0,.43-.469l2.032-4.742a1.864,1.864,0,0,0,.091-.391,2.892,2.892,0,0,0,.039-.391v-.625a.609.609,0,0,0-.7-.7H90.214l.756-3.6a.745.745,0,0,0,0-.391.711.711,0,0,0-.182-.313l-.547-.573-4.2,4.534-.208.417a.977.977,0,0,0-.1.443v5.394a1.515,1.515,0,0,0,.469,1.081A1.481,1.481,0,0,0,87.3,192Zm3.127,4.846a10.085,10.085,0,0,1-4.039-.821,10.5,10.5,0,0,1-5.563-5.563,10.411,10.411,0,0,1,0-8.1,10.416,10.416,0,0,1,2.241-3.309,10.684,10.684,0,0,1,3.322-2.228,10.411,10.411,0,0,1,8.1,0,10.406,10.406,0,0,1,5.537,5.537,10.411,10.411,0,0,1,0,8.1,10.684,10.684,0,0,1-2.228,3.322,10.416,10.416,0,0,1-3.309,2.241A10.149,10.149,0,0,1,90.422,196.845Zm0-1.563a8.852,8.852,0,1,0-6.266-2.593A8.525,8.525,0,0,0,90.422,195.281ZM90.422,186.422Z"
			transform="translate(-80 -176)"
			fill={color ?? '#126cfc'}
		/>
	</svg>
);

export const Chromecast: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" data-name="Group 8057" xmlns="http://www.w3.org/2000/svg" width="22.01" height="18" viewBox="0 0 22.01 18">
		<g data-name="Group 36" transform="translate(0 0)">
			<g data-name="Group 35">
				<path
					id="Path_42"
					data-name="Path 42"
					d="M170.6,295.308v14h-6.913v1.964c2.2,0,4.336,0,6.477,0,1.732,0,2.446-.718,2.448-2.454,0-4.333-.046-8.666.024-13a2.231,2.231,0,0,0-2.527-2.547c-5.656.042-11.313.016-16.968.018a5.786,5.786,0,0,0-.792.043,1.667,1.667,0,0,0-1.6,1.43,33.18,33.18,0,0,0-.031,3.474h1.928v-2.933Zm-9.069,15.937c.374-5.712-5.091-11.272-10.9-10.852,0,.425,0,.855,0,1.284,0,.166.017.331.026.5q8.206.889,9.071,9.069Zm-3.971,0c.139-4.576-4.317-7.318-6.907-6.836v1.8a5.187,5.187,0,0,1,5.046,5.038Zm-6.9-.017h2.932a2.812,2.812,0,0,0-2.932-2.876Z"
					transform="translate(-150.623 -293.276)"
					fill={color ?? '#fff'}
				/>
				<path
					id="Path_43"
					data-name="Path 43"
					d="M170.591,295.308H152.637v2.933h-1.928a33.192,33.192,0,0,1,.031-3.474,1.667,1.667,0,0,1,1.6-1.43,5.786,5.786,0,0,1,.792-.043c5.656,0,11.313.024,16.968-.018a2.231,2.231,0,0,1,2.527,2.547c-.07,4.332-.022,8.664-.024,13,0,1.737-.715,2.452-2.448,2.454-2.14,0-4.28,0-6.477,0v-1.964h6.913Z"
					transform="translate(-150.616 -293.276)"
					fill={color ?? '#fff'}
				/>
				<path
					id="Path_44"
					data-name="Path 44"
					d="M161.529,310.408h-1.806c-.57-5.459-3.833-8.811-9.071-9.069-.009-.168-.025-.333-.026-.5,0-.43,0-.859,0-1.284C156.437,299.136,161.9,304.7,161.529,310.408Z"
					transform="translate(-150.623 -292.44)"
					fill={color ?? '#fff'}
				/>
				<path
					id="Path_45"
					data-name="Path 45"
					d="M157.554,309.937h-1.861a5.187,5.187,0,0,0-5.046-5.038v-1.8C153.237,302.62,157.694,305.361,157.554,309.937Z"
					transform="translate(-150.62 -291.97)"
					fill={color ?? '#fff'}
				/>
				<path
					id="Path_46"
					data-name="Path 46"
					d="M150.656,309.45v-2.876a2.812,2.812,0,0,1,2.932,2.876Z"
					transform="translate(-150.619 -291.5)"
					fill={color ?? '#fff'}
				/>
			</g>
		</g>
	</svg>
);

export const AirPlay: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="23.04" height="18" viewBox="0 0 23.04 18">
		<g id="display" transform="translate(0 -2)">
			<path
				id="Path_662"
				data-name="Path 662"
				d="M6.13,13.957A4.532,4.532,0,0,0,6.457,12h5.218A4.532,4.532,0,0,0,12,13.957h.978a.652.652,0,0,1,0,1.3H5.152a.652.652,0,0,1,0-1.3Z"
				transform="translate(2.455 4.739)"
				fill={color ?? '#fff'}
			/>
			<path
				id="Path_663"
				data-name="Path 663"
				d="M20.147,3.474H2.88a1.477,1.477,0,0,0-.867.214,1.111,1.111,0,0,0-.366.445,2.192,2.192,0,0,0-.207.83v8.829a1.566,1.566,0,0,0,.209.887,1.1,1.1,0,0,0,.435.374,2.07,2.07,0,0,0,.775.211h17.3a1.477,1.477,0,0,0,.867-.214,1.111,1.111,0,0,0,.366-.445,2.2,2.2,0,0,0,.206-.793V4.948a1.566,1.566,0,0,0-.209-.887,1.1,1.1,0,0,0-.435-.374,2.064,2.064,0,0,0-.811-.212ZM20.16,2H2.88A2.867,2.867,0,0,0,0,4.948v8.843a2.842,2.842,0,0,0,2.88,2.948H20.16a2.867,2.867,0,0,0,2.88-2.948V4.948A2.842,2.842,0,0,0,20.16,2Z"
				fill={color ?? '#fff'}
				fillRule="evenodd"
			/>
		</g>
	</svg>
);

export const EnterPiP: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24.706" height="20" viewBox="0 0 24.706 20">
		<path
			className="shrink"
			d="M24.471,7a3.249,3.249,0,0,1,3.235,3.235V23.765A3.249,3.249,0,0,1,24.471,27H6.235A3.249,3.249,0,0,1,3,23.765V10.235A3.249,3.249,0,0,1,6.235,7Zm0,1.765H6.235a1.458,1.458,0,0,0-1.471,1.471V23.765a1.458,1.458,0,0,0,1.471,1.471H13v-5A3.235,3.235,0,0,1,16.235,17h9.706V10.235A1.458,1.458,0,0,0,24.471,8.765ZM7.429,10.521a.882.882,0,0,1,.607.267l3.2,3.2v-.811a.882.882,0,1,1,1.765,0v2.81A.882.882,0,0,1,11.988,17H9.176a.882.882,0,1,1,0-1.765h.811l-3.2-3.2a.882.882,0,0,1,.641-1.514Z"
			transform="translate(-3 -7)"
			fill={color ?? '#fff'}
		></path>
	</svg>
);

export const ExitPiP: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g className="Group_197" data-name="Group 197" transform="translate(-1311 -10)">
			<path
				className="toggle-full-screen"
				d="M24.471,7a3.249,3.249,0,0,1,3.235,3.235V23.765A3.249,3.249,0,0,1,24.471,27H6.235A3.249,3.249,0,0,1,3,23.765V10.235A3.249,3.249,0,0,1,6.235,7Zm0,1.765H6.235a1.458,1.458,0,0,0-1.471,1.471V23.765a1.458,1.458,0,0,0,1.471,1.471H13v-5A3.235,3.235,0,0,1,16.235,17h9.706V10.235A1.458,1.458,0,0,0,24.471,8.765ZM7.429,10.521a.882.882,0,0,1,.094.008h2.83a.882.882,0,1,1,0,1.765H9.542l3.2,3.2a.882.882,0,1,1-1.248,1.248l-3.2-3.2v.811a.882.882,0,1,1-1.765,0V11.514a.882.882,0,0,1,.9-.993Z"
				transform="translate(1318.147 15.5)"
				fill={color ?? '#fff'}
			></path>
		</g>
	</svg>
);

export const X: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.25342 5.36694L16.2731 18.7639H18.5421L8.52241 5.36694H6.25342Z" fill={color ?? '#fff'} />
		<path
			d="M22.6752 2.71477e-08H1.32363C0.592529 0.00043948 -0.000146457 0.593408 2.71477e-08 1.3248V22.6764C0.00043948 23.4075 0.593408 24.0001 1.3248 24H22.6752C23.4067 24.0001 23.9999 23.4073 24 22.6758V1.32363C23.9997 0.592529 23.4066 -0.000146457 22.6752 2.71477e-08ZM15.7377 19.8329L11.176 13.7334L5.53002 19.8329H4.07854L10.5273 12.8663L4.11893 4.29783H9.05802L13.2592 9.91516L18.4588 4.29783H19.9102L13.9077 10.7825L20.6768 19.8329H15.7377Z"
			fill={color ?? '#fff'}
		/>
	</svg>
);

export const LinkedIn: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.2691 0H1.7309C0.774902 0 0 0.774902 0 1.7309V22.2691C0 23.2251 0.774902 24 1.7309 24H22.2691C23.2251 24 24 23.2251 24 22.2691V1.7309C24 0.774902 23.2251 0 22.2691 0ZM8.51294 18.1406H5.59039V9.34808H8.51294V18.1406ZM7.05176 8.14746H7.03271C6.052 8.14746 5.41772 7.47235 5.41772 6.6286C5.41772 5.76581 6.07141 5.10938 7.07117 5.10938C8.07092 5.10938 8.68616 5.76581 8.7052 6.6286C8.7052 7.47235 8.07092 8.14746 7.05176 8.14746ZM19.051 18.1406H16.1288V13.4368C16.1288 12.2547 15.7057 11.4485 14.6483 11.4485C13.8409 11.4485 13.3601 11.9923 13.1488 12.5173C13.0715 12.7051 13.0527 12.9677 13.0527 13.2305V18.1406H10.1303C10.1303 18.1406 10.1686 10.173 10.1303 9.34808H13.0527V10.593C13.441 9.9939 14.1359 9.14172 15.6865 9.14172C17.6093 9.14172 19.051 10.3984 19.051 13.099V18.1406Z"
			fill={color ?? '#fff'}
		/>
	</svg>
);

export const Facebook: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.6752 2.71477e-08H1.32363C0.592529 0.000439482 -0.000146457 0.593408 2.71477e-08 1.3248V22.6764C0.000439482 23.4075 0.593408 24.0001 1.3248 24H12.8203V14.7188H9.70312V11.0859H12.8203V8.41245C12.8203 5.31211 14.713 3.62461 17.4787 3.62461C18.8033 3.62461 19.9417 3.72334 20.2734 3.76743V7.00781H18.3664C16.8617 7.00781 16.5703 7.7228 16.5703 8.77222V11.0859H20.168L19.6992 14.7188H16.5703V24H22.6752C23.4067 24.0001 23.9999 23.4073 24 22.6758V1.32363C23.9997 0.592529 23.4066 -0.000146457 22.6752 2.71477e-08Z"
			fill={color ?? '#fff'}
		/>
	</svg>
);

export const Email: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_83_211)">
			<path
				d="M22.6752 2.71477e-08H1.32363C0.592529 0.00043948 -0.000146457 0.593408 2.71477e-08 1.3248V22.6764C0.00043948 23.4075 0.593408 24.0001 1.3248 24H22.6752C23.4067 24.0001 23.9999 23.4073 24 22.6758V1.32363C23.9997 0.592529 23.4066 -0.000146457 22.6752 2.71477e-08ZM5.62072 4.96593H18.3793C18.7894 4.96593 19.1749 5.06344 19.5239 5.22566L12.0419 11.7662L4.52166 5.20105C4.85794 5.05251 5.22885 4.96593 5.62072 4.96593ZM2.88674 16.2992V7.69991C2.88674 7.25245 3.00521 6.83597 3.19659 6.46324L8.2991 10.9196L3.03164 17.1376C2.94506 16.8715 2.88674 16.5935 2.88674 16.2992ZM18.3802 19.0341H5.62163C5.08851 19.0341 4.59548 18.8746 4.17444 18.6103L9.67338 12.118L11.4432 13.6636C11.6136 13.814 11.8287 13.8887 12.0419 13.8887C12.2552 13.8887 12.4702 13.814 12.6416 13.6636L14.353 12.1672L19.8274 18.6103C19.4063 18.8746 18.9133 19.0341 18.3802 19.0341ZM21.1133 16.2992C21.1133 16.5935 21.0549 16.8724 20.9674 17.1385L15.7255 10.9679L20.828 6.5079C21.0048 6.86878 21.1133 7.27067 21.1133 7.69991V16.2992Z"
				fill={color ?? '#fff'}
			/>
		</g>
		<defs>
			<clipPath id="clip0_83_211">
				<rect width="24" height="24" fill={color ?? '#fff'} />
			</clipPath>
		</defs>
	</svg>
);

export const Embedded: React.FC<QPlayerSVGElementProps> = ({ color }) => (
	<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.2691 0H1.7309C0.774902 0 0 0.774902 0 1.7309V22.2691C0 23.2251 0.774902 24 1.7309 24H22.2691C23.2251 24 24 23.2251 24 22.2691V1.7309C24 0.774902 23.2251 0 22.2691 0ZM10.0348 15.477L8.97656 16.5352L4.44141 12L8.97656 7.46484L10.0537 8.54194L6.57671 12.0189L10.0348 15.477ZM15.0234 16.5352L13.9463 15.4581L17.4233 11.9811L13.9652 8.52305L15.0234 7.46484L19.5586 12L15.0234 16.5352Z"
			fill={color ?? '#fff'}
		/>
	</svg>
);
